/** @modu le csi/widget/HorizontalSlider */
define([
	"jquery",
	"dojo/_base/declare",
	"dojo/has",
	"dojo/dom-geometry",
	"dijit/focus",
	"dijit/form/HorizontalSlider",
	"csi/html"
], function($, declare, has, domGeometry, focus, HorizontalSlider, html) {
	return declare([HorizontalSlider], {

		/**
		 * @override
		 * C8-13857
		 * Set to false to prevent _FormWidgetMixin to scrollIntoView every time when slider gets focus
		 * _FormWidgetMixin._onFocus() {...
		 * 		if(this.scrollOnFocus){
		 * 				this.defer(function(){
		 * 					winUtils.scrollIntoView(this.domNode);   
		 */
		scrollOnFocus: false,

		/**
		 * @override
		 * Set explicite height of sliderBarCotnainer to prevent height == 0
		 */
		startup: function() {
			this.inherited(arguments);
			// Force height of empty (no content) div container (for FF)
			$(this.sliderBarContainer).height(this.domNode.offsetHeight);
		},

		/**
		 * Extension for operation before onHandleClick
		 * * @property {event} e
		 */
		preHandleClick: function(e) { },

		/**
		 * Extension for operation after onHandleClick
		 * * @property {event} e
		 */
		postHandleClick: function(e) { },

		/**
		 * Add extensions to override _onHandleClick to add pre and post actions
		 * * @property {event} e
		 */
		_onHandleClick: function(e) {
			this.preHandleClick(e);
			if (!has('safari')) {
				this.inherited(arguments);
			} else {
				this._onHandleClickSafari(e);
			}
			this.postHandleClick(e);
		},

		/**
		 * Clone of method from difit/form/HorizontalSlider->_onHandleClick() with removed call to focus.focus(this.sliderHandle) to avoid Safari bug C8-25242
		 */
		_onHandleClickSafari: function(e) {
			if (this.disabled || this.readOnly) {
				return;
			}
			e.stopPropagation();
			e.preventDefault();
		},

		/**
		 * Clone of method from difit/form/HorizontalSlider with removed call to focus.focus(this.sliderHandle) to avoid Safari bug C8-25242
		 */
		_onBarClick: function(e) {
			if (this.disabled || this.readOnly || !this.clickSelect) {
				return;
			}
			if (!has('safari')) {
				focus.focus(this.sliderHandle);
			}
			e.stopPropagation();
			e.preventDefault();
			var abspos = domGeometry.position(this.sliderBarContainer, true);
			var pixelValue = e[this._mousePixelCoord] - abspos[this._startingPixelCoord];
			this._setPixelValue(this._isReversed() ? (abspos[this._pixelCount] - pixelValue) : pixelValue, abspos[this._pixelCount], true);
			this._movable.onMouseDown(e);
		},

		/**
		 * @override
		 * Ensure widget is not destroyed before proceeding - this fixes an error coming from onMouseMove event;
		 * not exactly sure how that happens as the event looks to be cleaned up when slider is destroyed
		 */
		_setPixelValue(pixelValue, maxPixels, priorityChange) {
			if (!this._destroyed) {
				this.inherited(arguments);
			}
		}
	});
});